var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgM2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27.5163,
    height: 27.5163,
    rx: 6.25815,
    fill: "#2F945C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9048 7.43121L13.2673 12.9697L15.9113 7.41556C15.9426 7.36863 15.9896 7.32169 16.0678 7.32169H19.7132C19.7757 7.32169 19.8227 7.35298 19.854 7.39992C19.8853 7.44685 19.8853 7.49379 19.8696 7.55637L19.4315 8.65155V16.9436L19.8696 18.0388C19.8853 18.0857 19.8853 18.1483 19.854 18.1952C19.8227 18.2422 19.7757 18.2578 19.7132 18.2578H16.146C16.0991 18.2578 16.0521 18.2422 16.0209 18.1952C15.9896 18.1483 15.9739 18.0857 16.0052 18.0388L16.4433 16.9436V10.4351L12.704 18.3673C12.6727 18.4299 12.6102 18.4612 12.5476 18.4612C12.485 18.4612 12.4381 18.4143 12.4068 18.3673L9.15253 10.7793V16.5055L9.77834 18.0388C9.79399 18.0857 9.79399 18.1483 9.7627 18.1952C9.73141 18.2422 9.68447 18.2578 9.62189 18.2578H6.91524C6.85266 18.2578 6.80572 18.2422 6.77443 18.1952C6.74314 18.1483 6.74314 18.0857 6.75879 18.0388L7.3846 16.5055V8.65155L6.94653 7.55637C6.91524 7.49379 6.93088 7.44685 6.96218 7.39992C6.99347 7.35298 7.0404 7.32169 7.08734 7.32169H10.764C10.8266 7.32169 10.8892 7.36863 10.9048 7.43121Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM2);
export default __webpack_public_path__ + "static/media/m2.2671e619004cb63c87c87cf9a22b0f44.svg";
export { ForwardRef as ReactComponent };